import { Appointment } from "../appointment.entity";
import { Doctor } from "../../user.entity/doctor.entity";
import { User } from "../../user.entity";

export class PatientAppointment extends Appointment {
    doctor: Doctor;
    patient: User;
    language: string;

    constructor(other?: Partial<PatientAppointment>) {
        super(other)
        this.doctor = other?.doctor || new Doctor();
        this.language = other?.language || '';
        this.patient = other?.patient || new User()
    }

    static fromResponse(res: any) {
        return new PatientAppointment({
            doctor: Doctor.fromResponse(res.doctor),
            patient: res.patient?User.fromResponse(res.patient):undefined,
            ...Appointment.fromResponse(res)
        });
    }
}
